var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconSettingsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.66675 10.7333V9.26667C1.66675 8.4 2.37508 7.68333 3.25008 7.68333C4.75841 7.68333 5.37508 6.61667 4.61675 5.30833C4.18341 4.55833 4.44175 3.58333 5.20008 3.15L6.64175 2.325C7.30008 1.93333 8.15008 2.16667 8.54175 2.825L8.63341 2.98333C9.38341 4.29167 10.6167 4.29167 11.3751 2.98333L11.4667 2.825C11.8584 2.16667 12.7084 1.93333 13.3667 2.325L14.8084 3.15C15.5667 3.58333 15.8251 4.55833 15.3917 5.30833C14.6334 6.61667 15.2501 7.68333 16.7584 7.68333C17.6251 7.68333 18.3417 8.39167 18.3417 9.26667V10.7333C18.3417 11.6 17.6334 12.3167 16.7584 12.3167C15.2501 12.3167 14.6334 13.3833 15.3917 14.6917C15.8251 15.45 15.5667 16.4167 14.8084 16.85L13.3667 17.675C12.7084 18.0667 11.8584 17.8333 11.4667 17.175L11.3751 17.0167C10.6251 15.7083 9.39175 15.7083 8.63341 17.0167L8.54175 17.175C8.15008 17.8333 7.30008 18.0667 6.64175 17.675L5.20008 16.85C4.44175 16.4167 4.18341 15.4417 4.61675 14.6917C5.37508 13.3833 4.75841 12.3167 3.25008 12.3167C2.37508 12.3167 1.66675 11.6 1.66675 10.7333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 12.7083C11.4959 12.7083 12.7084 11.4958 12.7084 10C12.7084 8.50423 11.4959 7.29167 10.0001 7.29167C8.50431 7.29167 7.29175 8.50423 7.29175 10C7.29175 11.4958 8.50431 12.7083 10.0001 12.7083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconSettingsActive);
export default __webpack_public_path__ + "static/media/menu_icon_settings_active.7cdda1c9d9c3eab61361940f77d32b0f.svg";
export { ForwardRef as ReactComponent };